<section class="course-main pd-t40 pd-b40 pd-l40 pd-r40 pd-sm-20 lightgrey-bg pd-sm-l15 pd-sm-r15">
    <div class="smallContainer mg-auto">
        <ng-container *ngIf="currentUserCourse?.progress == 100">
            <!-- <ng-container> -->
            <article class="course-compl light-bg d-flex">
                <div class="course-compl--img d-flex">
                    <img src="./../../../../../assets/images/course-completion-icon.png" alt=""/>
                </div>
                <div class="course-compl__right">
                    <h2 class="dark-color text-capitalize">
                        Good job, {{user?.firstName | titlecase}}
                    </h2>
                    <h3>This course is now complete.</h3>
                    <p>Here are your Thrive Scores for {{currentUserCourse?.courseName | titlecase}}.</p>
                </div>
            </article>

            <article class="program-comp course-wrap">
                <div class="know-comp__text pd-t30 pd-b40 pd-sm-t25 pd-sm-b30">
                    <a class="cursor-pointer" (click)="showPopupModal()">Know more about Thrive Skills</a>
                </div>

                <!-- program completion topics -->

                <div class="proc__topics d-flex" *ngFor="let ts of currentUserCourse?.courseBloScore">
                    <div class="proc__topics-cont d-flex">
                        <div class="proc__topics-cont--left">
                            <h3 [innerHTML]="ts?.shortStatement"></h3>
                            <h5 [innerHTML]="ts?.statement"></h5>
                        </div>
                        <div class="proc__topics-cont--right">
                            <div class="proc__topics-cont--right-top">Points Earned
                                <!-- <span class="final--result">{{ts?.gainedMarks}}/{{ts?.totalMarks}}</span> -->
                                <span class="final--result">{{(ts?.gainedMarks/ts?.totalMarks) | percent: '1.0-0'}}</span>

                            </div>
                            <!-- Progres Bar -->
                            <div class="points--bar-main">
                                <div class="points--bar-color"
                                    [ngStyle]="{'width': (ts?.gainedMarks/ts?.totalMarks*100)+'%'}" [ngClass]="{
                                    'points--bar-color-excel': (ts?.gainedMarks/ts?.totalMarks*100) > 60,
                                    'points--bar-color-good':  ((ts?.gainedMarks/ts?.totalMarks*100) <= 60) && ((ts?.gainedMarks/ts?.totalMarks*100) > 30),
                                    'points--bar-color-poor':  (ts?.gainedMarks/ts?.totalMarks*100) <= 30
                                }"></div>
                                <div class="points--bar-bg" [ngClass]="{
                                    'points--bar-color-excel': (ts?.gainedMarks/ts?.totalMarks*100) > 60,
                                    'points--bar-color-good':  ((ts?.gainedMarks/ts?.totalMarks*100) <= 60) && ((ts?.gainedMarks/ts?.totalMarks*100) > 30),
                                    'points--bar-color-poor':  (ts?.gainedMarks/ts?.totalMarks*100) <= 30
                                }"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- program completion topics end -->

            </article>
            <article class="unlocked-section" *ngIf="habitDrillSection">
                <h5>Congrats! You've unlocked a {{dynamicHabitDrillNomenclature}}</h5>
                <h2>{{dynamicHabitDrillNomenclature}} : {{habitDrillTitle | titlecase}}</h2>
                <button (click)="habitDrillDetails()"
                    class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20">
                    START ACTIVITY
                </button>
            </article>
        </ng-container>


        <div class="new-question pr-0 pl-0">
            <div class="new-question__container">
                <div class="" style="max-width: 680px; margin: 0 auto;">
                    <!-- <div
                class="pd-t15 pd-b15 pd-r15 pd-l15 mg-b30 certificate-block text-left light-bg div-shadow justify-content-between br-5 border-none-i" *ngIf="currentUserCourse?.progress != 100">
                <div class="row d-flex text-xl-left align-items-center mb-4 mb-xl-0">
                    <div class="col-md-auto">
                        <ng-container *ngIf="currentUserCourse?.progress == 100; else notCompletedImage">
                            <img class="mx-auto d-block d-md-none" src="assets/images/acedemy.png" alt="" />
                            <img class="d-none d-md-block" src="assets/images/acedemy.png" alt="" />
                        </ng-container>
                        <ng-template #notCompletedImage>
                            <img class="mx-auto d-block d-md-none" src="assets/images/course-progress.png" alt="" />
                            <img class="d-none d-md-block" src="assets/images/course-progress.png" alt="" />
                        </ng-template>
                    </div>
                    <div class="col mob-text-center mg-x-b20">
                        <h3 class="mg-b5 navColor montserrat-semibold font-20">Hey, {{user?.firstName}}!</h3>
                        <p class="font-15 textColor">{{userStatus.line2}}
                            <br />{{userStatus.line3}}
                        </p>
                    </div>
                    <div *ngIf="currentUserCourse?.progress == 100 && user?.organization != 'SAMSHIKSHA' && !course?.muteScores"
                        class="col-md-4 border-left border-left-xs-none border-top-xs pd-t20">
                        <p class="text-center font-16 navColor lh-24">Your <span
                                class="has-tooltip has-tooltip--mobilevisible"
                                [class.h-score]="course?.courseTypeVersion == '2'">{{(evaluationResult?.isNewEvaluation
                                ? (course?.courseTypeVersion == '2' ? 'H_Score' : 'Course Score') : 'Score')}}
                                <span *ngIf="course?.courseTypeVersion == '2'"
                                    class="custom-tooltip custom-tooltip--white white-space-wrap no-border">
                                    The H_Score is the measure of your performance in a course. It is calculated as a
                                    percentage. The maximum H_Score you can get in a course is 100%.
                                </span>
                            </span> is</p>
                        <p class="text-center font-32 montserrat-semibold primaryColor"
                            *ngIf="!(inCompleteExercises?.length || pendingScores)">
                            {{(evaluationResult?.isNewEvaluation ? (course?.courseTypeVersion == '2' ?
                            evaluationResult?.points : totalPoints) : totalPercentage) | number: '1.0-0'}}%
                        </p>
                        <div class="text-center montserrat-semibolds pd-t15" *ngIf="pendingScores">
                            <i class="ms-2 icon-awaiting"></i><br>
                            <span class="awaiting-score__popup">Awaiting Score</span>
                        </div>
                    </div>
                </div>
            </div>
            <p *ngIf="pendingScores && !course?.muteScores" class="font-15 terneryColor mg-b50">Your H_Score will be
                generated as soon as our
                Harappa Learning Specialists have graded your assessments.</p>
            <div *ngIf="(currentUserCourse?.progress == 100) && course?.isGenerateCompletionCertificate && checkThreshold"
                class="pd-t15 pd-b15 pd-r15 pd-l15 certificate-block mg-b30 d-block d-xl-flex align-items-center text-left light-bg div-shadow justify-content-between">
                <div
                    class="d-block d-xl-flex text-center text-xl-left align-items-center justify-content-center mb-4 mb-xl-0">
                    <div class="pd-r20">
                        <i class="font-40 icon-certified primaryColor"></i>
                    </div>
                    <div class="pd-r20">
                        <h3 class="mg-b5 montserrat-bold font-14 navColor">Stand out amongst your peers and professional
                            network!</h3>
                    </div>
                </div>
                <div class="pl-2 pl-md-2 text-center">
                    <button data-bs-toggle="modal" data-bs-target="#updateModal" (click)="openCertificate()"
                        [ngClass]="{'btn-disabled': currentUserCourse?.progress !=100,'has-tooltip':currentUserCourse?.progress !=100,'certificate-btn':currentUserCourse?.progress !=100}"
                        [disabled]="currentUserCourse?.progress !=100"
                        class="btn btn-primary btn-disabled font-12 btn-sm nowrap" type="button">
                        <span class="d-flex align-items-center">COLLECT CERTIFICATE<span
                                *ngIf="currentUserCourse?.progress !=100" class="checkBox lock"></span></span>
                        <span *ngIf="currentUserCourse?.progress !=100" class="custom-tooltip custom-tooltip__top">To
                            unlock, please complete all course content</span>
                    </button>
                </div>
            </div>
            <div *ngIf="(currentUserCourse?.progress == 100) && course?.isGenerateCompletionCertificate && !checkThreshold"
                class="pd-t15 pd-b15 pd-r15 pd-l15 certificate-block mg-b30 d-block d-xl-flex align-items-center text-left light-bg div-shadow justify-content-between">
                <div
                    class="d-block d-xl-flex text-center text-xl-left align-items-center justify-content-center mb-4 mb-xl-0">
                    <div class="pd-r20">
                        <h3 class="mg-b5 montserrat-bold font-14 navColor">{{user?.firstName}}, We applaud your
                            perseverance. Unfortunately, your Course Score does not clear the threshold set by your
                            organization to unlock the certificate. Sorry about this. We are sure this is disappointing
                            but we hope the learning from the course was well worth your time.</h3>
                    </div>
                </div>
            </div>
            <ng-container
                *ngIf="evaluationResult?.isNewEvaluation && !course?.muteScores && (currentUserCourse?.progress == 100)">
                <div class="row mg-t60">
                    <div class="col-12 col-md-6 col-lg-6 col-xl-5 mg-b20">
                        <table class="skill-table mg-b15 mx-auto lable-outside" cellspacing="0">
                            <tr>
                                <td></td>
                                <td>Skill</td>
                                <td>Effort</td>
                                <td>Confidence</td>
                            </tr>
                            <tr *ngFor="let row of rows">
                                <td>{{row.level | titlecase}}</td>
                                <td *ngFor="let cell of cells" class="skill-table__cell">
                                    <span class="skill-table__mark has-tooltip has-tooltip--mobilevisible">
                                        <img *ngIf="row.level == gridResult[cell.parameter]"
                                            [src]="emojiReactions[(row.level)]" alt="">
                                        <span
                                            class="custom-tooltip custom-tooltip--white custom-tooltip__top white-space-wrap no-border">
                                            Throughout the course, we were helping you build your Skill, Effort and
                                            Confidence on
                                            {{config.courseTitle | titlecase}}.
                                        </span>
                                    </span>
                                </td>
                            </tr>

                        </table>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6 col-xl-7 text-left pl-md-4">
                        <p class="font-14 lh-26 navColor mg-b40 mg-tb-b40 pd-t30">{{evaluationResult?.message}}</p>
                        <div class="font-14 lh-26 navColor d-flex align-items-center mg-b40"
                            *ngIf="course?.courseTypeVersion == '2'">
                            Course Engagement
                            <a href="javascript:void(0)"
                                class="h-scores d-md-inline has-tooltip has-tooltip--mobilevisible">
                                <img class="ms-2"
                                    src="{{evaluationResult?.enaggmenetScoreThumbsUp?'assets/images/thumb-up.svg':'assets/images/thumb-down.svg'}}"
                                    alt="">
                                <span
                                    class="custom-tooltip custom-tooltip--white custom-tooltip__top white-space-wrap no-border">
                                    We measure your course engagement through your activity on the platform. You will
                                    come across various features within the learning platform that are designed to boost
                                    both interactivity and aid learning. A thumbs-up means you have engaged well during
                                    the course, while thumbs-down is a recommendation that you can do better.
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="pl-2 pl-md-2 text-center pb-4">
                <button *ngIf="(currentUserCourse?.progress == 100) && showPathwayBtn" (click)="navigateToPathway()"
                    class="btn btn-primary btn-disabled font-12 btn-sm nowrap" type="button">
                    <span class="d-flex align-items-center">SEE WHAT'S NEXT</span>
                </button>
            </div> -->
                    <h4
                        class="primaryColor font-12 montserrat-medium text-center mg-b15 mg-t 50 course-progress__heading ">
                        Course Progress Details</h4>
                    <ul id="FAQaccordion" class="courseAccordion">
                        <li class="card" *ngFor="let module of modules; let i = index;">
                            <div class="card-header" id="FAQheadingOne">
                                <h5 class="mb-0">
                                    <button class="btn btn-link d-flex justify-content-between" data-bs-toggle="collapse"
                                        attr.data-bs-target="#FAQOne{{i}}" aria-expanded="false" aria-controls="FAQOne">
                                        <i class="icon-correct pre-icon"
                                            *ngIf="isModuleCompleted(module); else incompleteIcon"></i>
                                        <ng-template #incompleteIcon>
                                            <i class="icon-info-circle-filled pre-icon"></i>
                                        </ng-template>
                                        {{module.moduleName}}
                                        <span class="status">{{!isModuleCompleted(module) ? '~ Incomplete' : ''}}</span>
                                        <i class="icon-arrow-down"></i>
                                    </button>
                                </h5>
                            </div>
                            <div id="FAQOne{{i}}" class="collapse" aria-labelledby="FAQheadingOne"
                                data-bs-parent="#FAQaccordion">
                                <div class="card-body">
                                    <ul class="course-chapter">
                                        <li *ngFor="let content of module.contents">
                                            <a href="javascript:void(0)" (click)="goToContent(content)">
                                                <i class="pre-icon icon-circleplay"
                                                    *ngIf="content.mediaType.includes('VIDEO')"></i>
                                                <i class="pre-icon icon-excercise"
                                                    *ngIf="content.mediaType=='HTML'"></i>
                                                {{content.title}}
                                                <i class="post-icon icon-correct"
                                                    *ngIf="isContentCompleted(content._id); else contentIncompleteIcon"></i>
                                                <ng-template #contentIncompleteIcon>
                                                    <i class="post-icon icon-info-circle-filled"></i>
                                                </ng-template>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Footer Button Section -->
        <div class="course-buttons">
            <button type="button" [routerLink]="['/dashboard']" [state]="{ reload: true}"
                class="light-color link-no-underline trans--button pd-t10 pd-b10 pd-l20 pd-r20 pd-sm-l10 pd-sm-r10 cursor-pointer">GO
                TO DASHBOARD
            </button>
            <button type="button" *ngIf="nextBtn" (click)="nextActiveItem()"
                class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20">Next</button>
        </div>
        <!-- Footer Button Section End -->
    </div>
</section>

<app-popup-modal *ngIf="showHidePopupModal" (hidePopupModal)="hidePopup($event)"></app-popup-modal>